import { Link } from 'react-router-dom';
import { Industry } from '../data/industries';
import { Icon } from './icons';

interface IndustryCardProps {
  industry: Industry;
}

function IndustryCard({ industry }: IndustryCardProps) {
  const to =
    industry.id === 'nonprofits' ? '/microsoft-365-setup' : '/services/automation-workflows';

  return (
    <div className="industry-card">
      <div className="industry-card-head">
        <span className="feature-icon">
          <Icon id={industry.icon} size={24} />
        </span>
        <div>
          <h3 className="industry-card-title">{industry.name}</h3>
          <p className="industry-card-tagline">{industry.tagline}</p>
        </div>
      </div>
      <ul className="segment-list industry-card-list">
        {industry.workflows.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <Link to={to} className="contact-link industry-card-link">
        See how &rarr;
      </Link>
    </div>
  );
}

export default IndustryCard;
